import { DEFAULT_LAYOUT } from '@/router/constants';
import {
  IconNav,
  IconExperiment,
  IconComputer,
} from '@arco-design/web-vue/es/icon';
import { AppRouteRecordRaw } from '../types';

const ROUTERS: AppRouteRecordRaw = {
  path: '/evaluation',
  name: 'Evaluation',
  component: DEFAULT_LAYOUT,
  redirect: '/evaluation/datasets',
  meta: {
    locale: 'menu.develop.evaluation.title',
    requiresAuth: true,
    roles: ['*'],
    order: 17,
    hideFirstMenu: true,
  },
  children: [
    {
      path: 'datasets',
      name: 'EvaluationDatasets',
      component: () => import('@/views/evaluation/datasets/index.vue'),
      meta: {
        locale: 'menu.develop.evaluation.datasets',
        requiresAuth: true,
        icon: IconNav,
        roles: ['*'],
        order: 17,
      },
    },
    {
      path: 'datasets/detail',
      name: 'EvaluationDatasetDetail',
      component: () => import('@/views/evaluation/datasets/detail.vue'),
      meta: {
        locale: 'menu.develop.evaluation.datasets',
        hideInMenu: true,
        requiresAuth: true,
      },
    },
    {
      path: 'experiments',
      name: 'EvaluationExperiments',
      component: () => import('@/views/evaluation/experiments/index.vue'),
      meta: {
        locale: 'menu.develop.evaluation.experiments',
        requiresAuth: true,
        icon: IconExperiment,
        roles: ['*'],
        order: 18,
      },
    },
    {
      path: 'experiments/detail',
      name: 'EvaluationExperimentDetail',
      component: () => import('@/views/evaluation/experiments/detail.vue'),
      meta: {
        locale: 'menu.develop.evaluation.experiments',
        hideInMenu: true,
        requiresAuth: true,
      },
    },
    {
      path: 'cost',
      name: 'EvaluationCost',
      component: () => import('@/views/evaluation/cost/index.vue'),
      meta: {
        locale: 'menu.develop.evaluation.cost',
        requiresAuth: true,
        roles: ['*'],
        order: 19,
        icon: IconComputer,
      },
    },
  ],
};

export default ROUTERS;
